export const capitalize = (string: string): string =>
  `${string.charAt(0).toUpperCase() + string.slice(1)}`;

export const pascalize = (string: string, separator: string) =>
  string
    .toLowerCase()
    .split(separator)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join('');
